module.exports = __webpack_public_path__ + "img/114.5053ad58.jpg";